import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PlaylistObjectivePlayground } = await import('./index');
    return {
        Component: PlaylistObjectivePlayground,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
